import React, { useState } from 'react';

import WorkflowsList from './WorkflowsList/WorkflowsList';
import CreateWorkflow from './CreateWorkflow/CreateWorkflow';
import WorkflowUpload from './WorkflowUpload/WorkflowUpload';

const Workflow = () => {
  const [showCreateWorkflow, setShowCreateWorkflow] = useState(false);
  const [showUploadFile, setShowUploadFile] = useState(false);

  return (
    <div>
      {showCreateWorkflow ? (
        <CreateWorkflow
          setShowCreateWorkflow={setShowCreateWorkflow}
          setShowUploadFile={setShowUploadFile}
        />
      ) : showUploadFile ? (
        <WorkflowUpload
        setShowCreateWorkflow={setShowCreateWorkflow}
        setShowUploadFile={setShowUploadFile}
        />
      ) : (
        <WorkflowsList
          setShowCreateWorkflow={setShowCreateWorkflow}
        />
      )}
    </div>
  )
}

export default Workflow